module.exports = __webpack_public_path__ + "img/smart-card-outline.05050c5e.svg";